import React from 'react';
import propTypes from 'prop-types';
import { Form, Field, reduxForm, Submit } from 'common/components/Form';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as v from 'common/validators';
import { CountryPhoneInput } from 'common/components/Form/CountryPhoneInput';

const validate = values => ({
  phone: v.required(values.phone) || v.countryPhoneNumber(values.phone),
});

export class SmsSubscriptionForm extends React.Component {
  static propTypes = {
    onSubmit: propTypes.func.isRequired,
  };

  render() {
    const { handleSubmit, isSubmitting, phoneVerificationId } = this.props;
    const disableField = Boolean(phoneVerificationId);

    return (
      <Form onSubmit={handleSubmit}>
        <Field
          name="phone"
          type="tel"
          placeholder={'Cell phone number'}
          component={CountryPhoneInput}
          label="Phone"
          disabled={disableField}
        />
        <Submit
          className="SmsSubscriptionForm__submit"
          processing={isSubmitting}
          disabled={isSubmitting}
        >
          sign up
        </Submit>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'sms_subscription_form',
  validate,
})(SmsSubscriptionForm);
